import { render, staticRenderFns } from "./PrintSongPage.vue?vue&type=template&id=06c2bf08&scoped=true&"
import script from "./PrintSongPage.vue?vue&type=script&lang=js&"
export * from "./PrintSongPage.vue?vue&type=script&lang=js&"
import style0 from "./PrintSongPage.vue?vue&type=style&index=0&id=06c2bf08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c2bf08",
  null
  
)

component.options.__file = "PrintSongPage.vue"
export default component.exports